import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Discipline() { 
  useEffect(() => {
    document.title = 'Discipline -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Rules</li>
                <li>Discipline</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Discipline</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12"> 
                    <p>Student are bound to follow the under mentioned Rules as long as they are studying in Mercy Memorial School</p>      
                    <ul className="mainlist">
                        <li>Students are urged to contribute to the high tone of the School by their manners and general behaviour.</li>
                        <li>As far as posture, cleanliness, silence, politeness, honesty, attention to work and respect to teachers and companions are concerned, the School should be looked upon as a place of reverence and discipline.</li>
                        <li>Absolute silence must be maintained at all places during the teaching hours, whether it is the library, the laboratories, computer room, the general assembly or on way to and from the class rooms.</li>
                        <li> Respect for one’s property as well as for that of the School and for the things belonging to others is a mark of a well-bred and responsible student. Any kind of damage done to the School must be re-instituted by paying price.</li>
                        <li> Students must always speak English in the School premises and maintain a high standard in their conversation.</li>
                        <li> Books, newspapers, pictures/ periodicals, games, articles and transistors or electronic instruments not pertaining to their daily work and not approved by the Principal should not be brought to the School.</li>
                        <li> The School does not accept responsibility for the loss of books, money, clothes, games, articles, watches, etc. of the students.</li>
                        <li> Students should at all costs avoid writing, carving on walls or desks as these are detrimental to good education and a sign of low taste.</li>
                        <li> The Principal may chastise a student for habitual idleness, disobedience or misconduct injurious to the moral tone of the School, by detention after class hours or by other minor punishments. He may  even dismiss a student or ask him to discontinue if he is guilty of serious irregularities.</li>
                        <li> No fines or collection for any purpose whatsoever may be made without the previous sanction of the Principal. So also presentation of gifts to members of the staff requires previous sanction.</li>
                        <li> In the absence of the teacher, the class monitor assumes responsibility for order and discipline of the class. He should fulfill his duty with loyalty and impartiality.</li>
                        <li> Students who are given responsibility should carry it out dutifully and impartially and In accordance with the direction of the Principal or the Teacher deputed by him. They should consider it as       a  service to the School and to their fellow students.</li>
                        <li> Students can always approach the Principal individually for any reasonable or sympathetic consideration but not collectively.</li>
                        <li> No student may take private tuition in any subject from any member of the School staff without the written permission of the Principal. All such tuitions must be discontinued one week before the examinations. </li>
                    </ul> 
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Discipline;
